import { AppProviderContext } from '@websrc/App/AppContext'
import { useHasConsent } from '@websrc/App/Hooks/useHasConsent/useHasConsent'
import { useLocale } from '@websrc/App/Hooks/useLocale'
import { usePath } from '@websrc/App/Hooks/usePath'
import { useContext, useEffect } from 'react'

export function LocaleCookie() {
  const locale = useLocale()
  const path = usePath()
  const hasConsent = useHasConsent()
  const { disableCookies } = useContext(AppProviderContext)

  useEffect(() => {
    if (!hasConsent || disableCookies) {
      return
    }

    try {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      document.cookie
    } catch (_error: unknown) {
      return
    }

    const currentCookie = document.cookie.match(`(^| )locale=([^;]+)`)
    const isHomePage = path.match(/^\/[a-z]{2}-[a-z]{2}\/?$/g)

    // If there is no cookie at the moment, or we are at the homepage, set locale cookie!
    if (!currentCookie || isHomePage) {
      const date = new Date()

      date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000)

      document.cookie = `locale=${locale}; expires=${date.toUTCString()}; path=/;`
    }
  }, [hasConsent, locale, path, disableCookies])

  return null
}
